import React from 'react';
import { motion } from 'framer-motion';
import { revealItem } from '../common/Reveal';
interface PageHeaderProps {
  title: string;
  subtitle: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  actions
}: PageHeaderProps) {
  return <motion.div variants={revealItem} className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-385" data-mp="1r5vtjnlvcfk0">
      <div data-id="element-386" data-mp="1w5i9w5wzubx1">
        <h1 className="font-display text-[32px] font-bold leading-tight tracking-tight text-ink" data-id="element-387" data-mp="1w5s2805igv5w">{title}</h1>
        <p className="mt-1 text-sm text-muted" data-id="element-388" data-mp="2130g3ojmmd1c">{subtitle}</p>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-3" data-id="element-389" data-mp="262wpy4f08yot">{actions}</div>}
    </motion.div>;
}